import { Footer } from '@tt/design-system';
import type { ReactNode } from 'react';
import { SiteHeader } from '../components/SiteHeader';

type AppLayoutProps = {
  children: ReactNode;
};

export function AppLayout({ children }: AppLayoutProps) {
  return (
    <>
      <SiteHeader variant="app" />
      <main id="main" className="min-h-[80vh] bg-night text-parchment">
        {children}
      </main>
      <Footer compact />
    </>
  );
}
